import * as actionTypes from '../constants/reducer'
import {apiCall} from '../../service/apiCall'
import { USER,PASS } from '../../service/base_url'
import {get, groupBy} from 'lodash'
import {setLoadingComment, setLoadingTable,setLoadingFilter,setLoading ,setLoadingBeranda} from './general'
import { setReducer } from './reducer'
import Cookie from 'universal-cookie'
import _ from 'lodash'
import { setPersist } from './persist'
const cookie=new Cookie()
const token=cookie.get('login_cookie_forum')

export const getForumSelection=(firstvisit_topic)=>async dispatch=>{
    dispatch(setLoadingTable(true))
    let dataReq={
        url:`/Forum/selection`,
        method:'GET',
        data:{
            headers:{ 'Authorization': `Bearer ${token}`},
        }
    }
    let res=await dispatch(apiCall(dataReq))
    if(get(res,'status')===200){
        dispatch(setLoadingTable(false))
        let new_channel=[]
        res.data.map((d)=>{
            let new_forum=[]
            d.forums.map((f)=>{
                if(firstvisit_topic){
                    new_forum.push({...f,isSelected:true})

                }else{
                    new_forum.push(f)
                }
            })
            new_channel.push({...d,forums:new_forum})
        })
        dispatch(setReducer({forum_selection:new_channel}))
        return res
        
    }else{
        dispatch(setLoadingTable(false))
    }
}
export const postForumSelection=(data)=>async dispatch=>{
    dispatch(setLoading(true))
    let dataReq={
        url:`/Forum/selection`,
        method:'POST',
        data:{
            data:data,
            headers:{ 'Authorization': `Bearer ${token}`},
        }
    }
    let res=await dispatch(apiCall(dataReq))
    if(get(res,'status')===204){
        await dispatch(setPersist({firstvisit_topic:false}))
        window.location.assign('/forum')
        
        return res
        // window.location.reload() 
    }else{
        dispatch(setLoading(false))
    }
}


export const getForumFilter=(tokens=token)=>async dispatch=>{
    dispatch(setLoadingTable(true))
    let dataReq={
        url:`/Forum/home`,
        method:'GET',
        data:{
            headers:{ 'Authorization': `Bearer ${tokens}`},
        }
    }
    let res=await dispatch(apiCall(dataReq))
    if(get(res,'status')===200){
        dispatch(setLoadingTable(false))
        dispatch(setReducer({forum_filter:res.data}))
        return res
        
    }else{
        dispatch(setLoadingTable(false))
    }
}

export const getTrending=(forumId,count)=>async dispatch=>{
    dispatch(setLoadingFilter(true))
    let dataReq={
        url:`/Forum/trending/${forumId}/${count}`,
        method:'GET',
        data:{
            headers:{ 'Authorization': `Bearer ${token}`},
        }
    }
    let res=await dispatch(apiCall(dataReq))
    if(get(res,'status')===200){
        dispatch(setLoadingFilter(false))
        dispatch(setReducer({trending:res.data}))
        return res
        
    }else{
        dispatch(setLoadingFilter(false))
    }
}

export const getBeranda=(slug)=>async dispatch=>{
    dispatch(setLoadingBeranda(true))
    let dataReq={
        url:`/Forum/list/post${slug}`,
        method:'GET',
        data:{
            headers:{ 'Authorization': `Bearer ${token}`},
        }
    }
    let res=await dispatch(apiCall(dataReq))
    if(get(res,'status')===200){
        dispatch(setLoadingBeranda(false))
        dispatch(setReducer({beranda:res.data}))
        dispatch(setPersist({forum_name:res.data.forumName}))
        dispatch(setReducer({forum_list:res.data.items}))
        
        return res
    }else{
        dispatch(setLoadingBeranda(false))
    }
}
export const getForumList=(slug)=>async dispatch=>{
    dispatch(setLoadingBeranda(true))
    let dataReq={
        url:`/Forum/list/post${slug}`,
        method:'GET',
        data:{
            headers:{ 'Authorization': `Bearer ${token}`},
        }
    }
    let res=await dispatch(apiCall(dataReq))
    if(get(res,'status')===200){
        dispatch(setLoadingBeranda(false))
        dispatch({
            type:actionTypes.SET_FORUM_LIST,
            payload:res.data.items
        })
        return res
    }else{
        dispatch(setLoadingBeranda(false))
    }
}
export const postDiskusi=(data)=>async dispatch=>{
    dispatch(setLoading(true))
    let dataReq={
        url:`/Forum`,
        method:'POST',
        data:{
            data:data,
            headers:{ 'Authorization': `Bearer ${token}`,'Content-Type': 'multipart/form-data'},
        }
    }
    let res=await dispatch(apiCall(dataReq))
    if(get(res,'status')===200){
        // window.location.assign('/forum')
        dispatch(setLoading(false))
        
        return res
        // window.location.reload() 
    }else{
        dispatch(setLoading(false))
    }
}
export const putDiskusi=(data)=>async dispatch=>{
    dispatch(setLoading(true))
    let dataReq={
        url:`/Forum`,
        method:'PUT',
        data:{
            data:data,
            headers:{ 'Authorization': `Bearer ${token}`,'Content-Type': 'multipart/form-data'},
        }
    }
    let res=await dispatch(apiCall(dataReq))
    if(get(res,'status')===200){
        // window.location.assign('/forum')
        dispatch(setLoading(false))
        
        return res
        // window.location.reload() 
    }else{
        dispatch(setLoading(false))
    }
}
export const deleteDiskusi=(id)=>async dispatch=>{
    dispatch(setLoading(true))
    let dataReq={
        url:`/Forum/${id}`,
        method:'DELETE',
        data:{
            headers:{ 'Authorization': `Bearer ${token}`},
        }
    }
    let res=await dispatch(apiCall(dataReq))
    if(get(res,'status')===204){
        // window.location.assign('/forum')
        dispatch(setLoading(false))
        
        return res
        // window.location.reload() 
    }else{
        dispatch(setLoading(false))
    }
}
export const postForumAction=(slug)=>async dispatch=>{
    let dataReq={
        url:`/Forum${slug}`,
        method:'GET',
        data:{
            headers:{ 'Authorization': `Bearer ${token}`},
        }
    }
    let res=await dispatch(apiCall(dataReq))
    if(get(res,'status')===204){
        return res
    }else{
    }
}


export const getForumDetail=(slug)=>async dispatch=>{
    dispatch(setLoadingComment(true))
    let dataReq={
        url:`/Forum/detail/post${slug}`,
        method:'GET',
        data:{
            headers:{ 'Authorization': `Bearer ${token}`},
        }
    }
    let res=await dispatch(apiCall(dataReq))
    if(get(res,'status')===200){
        dispatch(setLoadingComment(false))
        let list_comment=[]
        res.data.items.map((data,i)=>{
            if(data.level!==0){
                list_comment.push(data)
            }
        })
        let fp=res.data.items.find(d=>d.level===0)
        let parrent={
            ...fp,
            child:[]
        }
        let level1=[]
        let level2=[]
        let level3=[]
        res.data.items.map((d)=>{
            if(d.level===1){
                level1.push({...d,child:[]})
            }
            if(d.level===2){
                level2.push({...d,child:[]})

            }
            if(d.level===3){
                level3.push({...d,child:[]})

            }
        })
        level3.map((d)=>{
            let findparent=level2.findIndex(f=>f.id===d.parentId)
            if(findparent>=0){
                level2[findparent].child.push(d)
            }
        })
        level2.map((d)=>{
            let findparent=level1.findIndex(f=>f.id===d.parentId)
            if(findparent>=0){
                level1[findparent].child.push(d)
            }
        })
        parrent.child=level1
        dispatch(setReducer({forum_detail:parrent}))
        return res
    }else{
        dispatch(setLoadingComment(false))
    }
}
export const getForumDetailBySlug=(slug)=>async dispatch=>{
    dispatch(setLoadingComment(true))
    let dataReq={
        url:`/Forum/detail${slug}`,
        method:'GET',
        data:{
            headers:{ 'Authorization': `Bearer ${token}`},
        }
    }
    let res=await dispatch(apiCall(dataReq))
    
    if(get(res,'status')===200){
        dispatch(setLoadingComment(false))
        let list_comment=[]
        res.data.items.map((data,i)=>{
            if(data.level!==0){
                list_comment.push(data)
            }
        })
        let fp=res.data.items.find(d=>d.level===0)
        let parrent={
            ...fp,
            child:[]
        }
        let level1=[]
        let level2=[]
        let level3=[]
        res.data.items.map((d)=>{
            if(d.level===1){
                level1.push({...d,child:[]})
            }
            if(d.level===2){
                level2.push({...d,child:[]})

            }
            if(d.level===3){
                level3.push({...d,child:[]})

            }
        })
        level3.map((d)=>{
            let findparent=level2.findIndex(f=>f.id===d.parentId)
            if(findparent>=0){
                level2[findparent].child.push(d)
            }
        })
        level2.map((d)=>{
            let findparent=level1.findIndex(f=>f.id===d.parentId)
            if(findparent>=0){
                level1[findparent].child.push(d)
            }
        })
        parrent.child=level1
        dispatch(setReducer({forum_detail:parrent}))
        return parrent
    }else{
        dispatch(setLoadingComment(false))
    }
}

export const getSearch=(slug)=>async dispatch=>{
    // console.log(`slug`, slug)
    dispatch(setLoadingBeranda(true))
    let dataReq={
        url:`/forum/search${slug}`,
        method:'GET',
        data:{
            headers:{ 'Authorization': `Bearer ${token}`},
        }
    }
    let res=await dispatch(apiCall(dataReq))
    if(get(res,'status')===200){
        dispatch(setLoadingBeranda(false))
        // dispatch(setReducer({beranda:res.data}))
        // dispatch(setPersist({forum_name:res.data.forumName}))
        let new_searchlist=[]
        res.data.items.map((d)=>{
            new_searchlist.push({...d,is_more:false})
        })
        dispatch(setReducer({search_list:new_searchlist}))
        dispatch(setReducer({beranda:res.data}))
        
        return res
    }else{
        dispatch(setLoadingBeranda(false))
    }
}